import type { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { useService } from '@xstate/react';
import interpreter from '../../state/service';
import DialogTransitionRoute from '../../utils/DialogTransitionRoute';
import FeedbackScreen from './FeedbackScreen.Container';
import SummaryScreen from './SummaryScreen.Container';
import { newPlaythrough } from '../../store/PlaythroughSlice';
import { addRating, resetRating } from '../../store/RatingSlice';

export interface Props {}

const Outro: FunctionComponent<Props> = () => {
	const dispatch = useDispatch();
	const [state, send] = useService(interpreter);

	return (
		<>
			<DialogTransitionRoute
				key="feedback"
				state={state}
				stateId="outro.feedback"
			>
				<FeedbackScreen
					onNext={(rating?: number) => {
						if (rating != null) {
							dispatch(addRating(rating));
						}
						send('NEXT');
					}}
				/>
			</DialogTransitionRoute>
			<DialogTransitionRoute
				key="summary"
				state={state}
				stateId="outro.summary"
			>
				<SummaryScreen
					onFinish={() => {
						dispatch(newPlaythrough({}));
						dispatch(resetRating());
						send('FINISH');
					}}
					onAgain={() => {
						dispatch(newPlaythrough({}));
						send('NEW');
					}}
				/>
			</DialogTransitionRoute>
		</>
	);
};

export default Outro;
